import React from 'react';
import Chip from '@mui/material/Chip';

export const STATUS_COLORS = {
  new: '#1976d2',
  open: '#0288d1',
  in_progress: '#fbc02d',
  resolved: '#43a047',
  closed: '#757575',
};

export const STATUS_LABELS = {
  new: 'Новый',
  open: 'Открыто',
  in_progress: 'В работе',
  resolved: 'Решен',
  closed: 'Закрыто',
};

export default function StatusChip({ status, label, color }) {
  const key = (status || '').toLowerCase();
  
  // Используем цвет из props, если он передан, иначе используем захардкоженный цвет
  const backgroundColor = color || STATUS_COLORS[key] || '#e0e0e0';
  
  // Используем метку из props, если она передана, иначе используем захардкоженную метку
  const displayLabel = label || STATUS_LABELS[key] || status;
  
  return (
    <Chip
      label={displayLabel}
      size="small"
      sx={{
        backgroundColor: backgroundColor,
        color: '#fff',
        fontWeight: 500,
        textTransform: 'none',
        letterSpacing: 0,
      }}
    />
  );
}
